import { SagaIterator } from 'redux-saga';
import { takeEvery, takeLatest } from 'redux-saga/effects';

import { setContentPermissions } from '~permissions/sagas/SetContentPermissionsSaga';
import {
  DeleteContents,
  EditWorkbook,
  NewWorkbookForDatasource,
  NewWorkbookForEditDatasource,
  OpenWorkbookInDesktopDialog,
  PublishToSalesforce,
  SetContentPermissions,
  SetOwner,
  SetTabsWorkbook,
  SetTags, UpdateDataFreshnessPolicy,
} from '~src/bootstrap/redux/actions/AppActionTypes';
import { updateDataFreshnessPolicySaga } from '~src/dataAcceleration/sagas/UpdateDataFreshnessPolicySaga';
import { handlePublishToSalesforceAction } from '~src/publishToSalesforce/saga/PublishToSalesforceSaga';
import { deleteContents } from '~src/spacesPlatform/sagas/content/DeleteContentsSaga';
import { handleSetTags } from '~src/spacesPlatform/sagas/SetTagsSagas';

import { handleEditWorkbookAction } from './EditWorkbookSaga';
import { handleNewWorkbookForDatasourceAction } from './NewWorkbookForDatasourceSagas';
import { handleNewWorkbookForEditDatasourceAction } from './NewWorkbookForEditDatasource';
import { handleOpenWorkbookInDesktop } from './OpenWorkbookInDesktopSaga';
import { handleSetOwner } from './SetOwnerSagas';
import { setTabsWorkbookSaga } from './SetTabsWorkbookSaga';

export function* rootWorkbookSaga(): SagaIterator {
  yield takeEvery(SetOwner, handleSetOwner);
  yield takeEvery(SetTabsWorkbook, setTabsWorkbookSaga);
  yield takeLatest(SetTags, handleSetTags);
  yield takeEvery(DeleteContents, deleteContents);
  yield takeLatest(SetContentPermissions, setContentPermissions);
  yield takeEvery(EditWorkbook, handleEditWorkbookAction);
  yield takeEvery(OpenWorkbookInDesktopDialog, handleOpenWorkbookInDesktop);
  yield takeEvery(NewWorkbookForDatasource, handleNewWorkbookForDatasourceAction);
  yield takeEvery(NewWorkbookForEditDatasource, handleNewWorkbookForEditDatasourceAction);
  yield takeEvery(UpdateDataFreshnessPolicy, updateDataFreshnessPolicySaga);
  yield takeLatest(PublishToSalesforce, handlePublishToSalesforceAction);
}
